export default function getValueFromQuery(name, defaultValue) {
    var _a;
    const searchParams = new URLSearchParams((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search);
    if (!searchParams.has(name)) {
        return defaultValue;
    }
    return searchParams.get(name);
}
